import { useEffect, useState, useRef } from 'react';
import { useT } from '../i18n/useT';
import { stats as statsEn } from '../i18n/translations/en';
import { stats as statsEs } from '../i18n/translations/es';
import './Stats.css';

const statValues = [
    { id: 1, value: "65,050" },
    { id: 2, value: "$101,995" },
    { id: 3, value: "33.6" },
    { id: 4, value: "9.66", suffix: "%" },
];

const Stats = () => {
    const [isVisible, setIsVisible] = useState(false);
    const statsRef = useRef(null);
    const t = useT({ en: statsEn, es: statsEs });

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => { if (entries[0].isIntersecting) setIsVisible(true); },
            { threshold: 0.1 }
        );
        const currentRef = statsRef.current;
        if (currentRef) observer.observe(currentRef);
        return () => { if (currentRef) observer.unobserve(currentRef); };
    }, []);

    return (
        <section className="section stats-section section-alt" id="site-selection" ref={statsRef}>
            <div className="container">
                <div className="section-header text-center">
                    <h2 className="section-title">{t.title}<span>{t.titleSpan}</span></h2>
                    <p className="section-subtitle">{t.subtitle}</p>
                </div>
                <div className="stats-grid">
                    {statValues.map((stat, index) => (
                        <div
                            key={stat.id}
                            className={`stat-card ${isVisible ? 'animate-in' : ''}`}
                            style={{ animationDelay: `${index * 0.15}s` }}
                        >
                            <h3 className="stat-card-value">
                                {stat.value}
                                {stat.suffix && <span className="stat-suffix">{stat.suffix}</span>}
                            </h3>
                            <div className="stat-divider"></div>
                            <p className="stat-card-label">{t.items[index].label}</p>
                        </div>
                    ))}
                </div>
                <div className="text-center" style={{ marginTop: '3rem' }}>
                    <button className="btn btn-primary">{t.cta}</button>
                </div>
            </div>
        </section>
    );
};

export default Stats;
